import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { useContext } from 'react';
const ContextConsumer = ({
  contexts,
  children: renderProp,
  args = []
}) => renderProp(..._mapInstanceProperty(contexts).call(contexts, context => useContext(context)), ...args);
export default ContextConsumer;